import Mobile from './mobile.js';
import Sort from './sort.js';
import { Fancybox } from "@fancyapps/ui";

/* ASIDE BLOCK PAGE CATALOG */
class Accordion{
    allAccordion(){
        const acc = document.querySelectorAll( '._js-accordion-open' );
        const accBody = document.querySelectorAll( '._js-accordion' );

        acc.forEach( item => {
            item.addEventListener( 'click' , () => {
                if( item.closest( '._js-accordion' ).classList.contains( '_active' ) ){
                    accBody.forEach( el => el.classList.remove( '_active' ) );
                }else{
                    accBody.forEach( el => el.classList.remove( '_active' ) );
                    item.closest( '._js-accordion' ).classList.add( '_active' );
                }
            } )
        } );
    }
}

let accordion = new Accordion();
let mobile = new Mobile();
let sort = new Sort();

window.onload = function(){
    accordion.allAccordion();
    mobile.start();
    sort.start();
    Fancybox.bind();
};
